import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Flex, Space, Typography } from 'antd';

import { getSignInPath } from '@/shared/constants/router';
import { Link } from '@/shared/ui/link';

import { SignUpContent } from '../sign-up-content/sign-up-content';

interface SignUpCardAsForm {
    signUpFormSlot: ReactNode;
    agreementLinksSlot?: never;
    googleSignUpButtonSlot?: never;
}

interface SignUpCardAsChoice {
    signUpFormSlot?: never;
    agreementLinksSlot: ReactNode;
    googleSignUpButtonSlot: ReactNode;
}

type SignUpCardProps = SignUpCardAsForm | SignUpCardAsChoice;

export const SignUpCard = memo((props: SignUpCardProps) => {
    const { signUpFormSlot, googleSignUpButtonSlot, agreementLinksSlot } =
        props;

    const { t } = useTranslation('auth');

    return (
        <Card
            className="auth-card"
            title={
                <Typography.Title level={2}>
                    {t('signUpCardTitle')}
                </Typography.Title>
            }
        >
            <Space
                className="full-width"
                direction="vertical"
                size={16}
            >
                {signUpFormSlot || (
                    <SignUpContent
                        agreementLinksSlot={agreementLinksSlot}
                        googleSignUpButtonSlot={googleSignUpButtonSlot}
                    />
                )}

                <Flex justify="center">
                    <Space size={4}>
                        <Typography.Text>
                            {t('signUpCardQuestion')}
                        </Typography.Text>
                        <Link to={getSignInPath()}>{t('signUpCardLink')}</Link>
                    </Space>
                </Flex>
            </Space>
        </Card>
    );
});

SignUpCard.displayName = 'SignUpCard';
